"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectWrapper = exports.HeadingWrapper = exports.Divider = exports.Level2Wrapper = exports.Level2List = exports.Chevron = exports.Level1Header = exports.Level1Wrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const chevron_down_svg_1 = __importDefault(require("../../../theme/svgs/chevron-down.svg"));
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.Level1Wrapper = styled_components_1.default.div `
  margin-bottom: 10px;
`;
exports.Level1Header = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
exports.Chevron = styled_components_1.default.span `
  margin-right: 8px;
  cursor: pointer;
`;
exports.Level2List = styled_components_1.default.div `
  margin-left: 20px;
`;
exports.Level2Wrapper = styled_components_1.default.div `
  margin-left: 20px;
`;
exports.Divider = styled_components_1.default.div `
  border-bottom: 1px solid ${colors_1.LIGHT_GREY};
  margin-top: 10px;
  margin-bottom: 10px;
`;
exports.HeadingWrapper = styled_components_1.default.div `
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  width: fit-content;
  min-width: 252px;
  display: flex;
  align-items: center;
  padding-left: 14px;
  height: 38px;
  font-size: 16px;
  line-height: 32px;
  font-weight: 400;
  box-sizing: border-box;
  border: 1px solid ${colors_1.GREY1};
  color: ${colors_1.GREY4};
  font-family: SwegonBrown;
  background-image: url("${chevron_down_svg_1.default}");
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    background-image: url("${chevron_down_svg_1.default}");
    outline: 0;
    border: 1px solid ${colors_1.GREY4};
  }
`;
exports.MultiSelectWrapper = styled_components_1.default.div `
  padding: 15px 16px 15px 18px;
  background: ${colors_1.WHITE};
  width: fit-content;
  box-shadow: 0px -1px 12px rgba(0, 0, 0, 0.06), 0px 15px 16px rgba(0, 0, 0, 0.08), 0px 5px 14px rgba(0, 0, 0, 0.07);
  min-width: 218px;
  margin-left: -1px;
  position: absolute;
  z-index: 99;
  max-height: 200px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 12px;
    height: 0.5em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors_1.GREY2};
    border-radius: 22px;
  }
`;
//# sourceMappingURL=MultiSelect.styles.js.map